<template>
    <td-login :sPlatformFlg="sPlatformFlg" :systemName="systemName" @loginSucess="loginSucess"></td-login>
</template>
<script>
export default {
    data() {
        return {
            sPlatformFlg: window.app.sPlatformFlg, // 登录入口标识
            systemName: window.vue.$t('component.SYSTEMNAME')
        };
    },
    created() {
        sessionStorage.setItem('systemName', this.systemName);
    },
    methods: {
        /* 登录成功后调用 */
        loginSucess() {}
    }
};
</script>
